import { LeaderboardRecord } from '../types';

const firstNames = ['Minh', 'Ngọc', 'Hải', 'Thanh', 'Quỳnh', 'Hoàng', 'Bảo', 'Khánh', 'Thu', 'Gia'];
const lastNames = ['Anh', 'Linh', 'Nam', 'Vy', 'Khang', 'Hà', 'An', 'Phương', 'Huy', 'Trâm'];

export const LEADERBOARD_TITLES: Record<string, string> = {
  tower: 'Leo tháp · Thường',
  competition: 'Leo tháp · Thi tuần',
  draw: 'Vẽ và đoán',
  puzzle: 'Ghép tranh'
};

const seeds: Record<string, string[]> = {
  tower: ['Mai Linh', 'Hải Nam', 'Hồng Anh'],
  competition: ['Minh Khang', 'Thu Hà', 'Bảo Ngọc'],
  draw: ['Lan Vy', 'Tuấn Minh', 'Khánh An'],
  puzzle: ['Ngọc Mai', 'Đức Anh', 'Thanh Hà']
};

const mineRanks: Record<string, number> = {
  tower: 24,
  competition: 18,
  draw: 31,
  puzzle: 28
};

export const PUZZLE_LEVELS = [
  'Em Thúy · 2×2',
  'Hai thiếu nữ và em bé · 2×2',
  'Bình Phong · 3×3',
  'Bác Hồ ở chiến khu Việt Bắc · 3×3',
  'Kết nạp Đảng ở Điện Biên Phủ · 4×4',
  'Gióng · 4×4'
];

const formatTime = (seconds: number) => {
  const m = String(Math.floor(seconds / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${m}:${s}`;
};

export function getLeaderboardRecords(
  game: 'tower' | 'competition' | 'draw' | 'puzzle',
  season: 'all' | 'season' = 'all',
  puzzleIdx: number = 0
): LeaderboardRecord[] {
  return Array.from({ length: 100 }, (_, i) => {
    const rank = i + 1;
    const isYou = rank === (mineRanks[game] || 20);
    const name = isYou
      ? 'Bạn · An'
      : (seeds[game]?.[i] || `${firstNames[Math.floor(i / 10) % firstNames.length]} ${lastNames[i % lastNames.length]}`);
    const isSeasonal = season === 'season' && game !== 'competition';

    if (game === 'draw') {
      const score = 5000 - i * 39 - (isSeasonal ? 700 : 0);
      return {
        rank,
        name,
        you: isYou,
        score,
        metric: `${score.toLocaleString('vi-VN')} điểm`,
        detail: 'Điểm vẽ + đoán hợp lệ'
      };
    }

    if (game === 'puzzle') {
      const score = 40 + puzzleIdx * 75 + i * 4 + (isSeasonal ? 8 : 0);
      return {
        rank,
        name,
        you: isYou,
        score,
        metric: formatTime(score),
        detail: `${PUZZLE_LEVELS[puzzleIdx] || 'Màn chơi'} · ${12 + puzzleIdx * 18 + i} thao tác`
      };
    }

    const floor = (game === 'competition' ? 14 : 18) - Math.floor(i / 8) - (isSeasonal ? 2 : 0);
    const correct = floor * 5 - (i % 8);
    return {
      rank,
      name,
      you: isYou,
      score: floor,
      metric: `${floor} tầng`,
      detail: `${correct} câu đúng · ${formatTime(200 + i * 11)}`
    };
  });
}
